module.exports = __webpack_public_path__ + "img/visiosign_cloud_logo_black.d71ea7cd.svg";